module.exports = __webpack_public_path__ + "static/media/track.33703677.png";